import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MatAccordion } from '@angular/material/expansion';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { PaisesConstants } from 'src/app/core/constants/paises';
import { AlertsService } from 'src/app/core/services/alerts.service';
import { SubdominiosService } from 'src/app/core/services/dominios.service';
import { TransactionsService } from 'src/app/core/services/transactions.service';
import { UsuarioService } from 'src/app/core/services/usuario.service';
import { UtilsService } from 'src/app/core/services/utils.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-account',
  templateUrl: './account.component.html',
  styleUrls: ['./account.component.scss'],
})
export class AccountComponent implements OnInit {
  @ViewChild(MatAccordion) accordion: MatAccordion;
  displayedColumnsTrans: string[] = [
    'tipo_de_evento',
    'valor_transaccion',
    'plan_comercial',
    'fecha_registro_transaccion',
    'fecha_de_caducidad',
    'actions',
  ];
  listTransactions = [];
  dataSourceTrans = new MatTableDataSource();
  @ViewChild(MatPaginator) paginatorTrans: MatPaginator;
  @ViewChild(MatSort) sortTrans: MatSort;

  public usuario = null;
  public empresa = null;
  public usuarioForm = null;
  public empresaForm = null;
  public fecha_de_nacimiento_usuario = '';
  public paises = PaisesConstants.countries.sort((a, b) => {
    const nameA = a.name_es.toUpperCase();
    const nameB = b.name_es.toUpperCase();
    if (nameA < nameB) {
      return -1;
    }
    if (nameA > nameB) {
      return 1;
    }

    return 0;
  });

  constructor(
    private fb: FormBuilder,
    private svUtils: UtilsService,
    private svUser: UsuarioService,
    private alertsService: AlertsService,
    private svSubdominios: SubdominiosService,
    private svTransactions: TransactionsService
  ) {}

  ngOnInit(): void {
    this.usuarioForm = this.fb.group({
      nombres_usuario: [null, [Validators.required]],
      apellidos_usuario: [null, [Validators.required]],
      correo_usuario: [null, [Validators.required]],
      telefono_usuario: [null, [Validators.required]],
      pais_usuario: [null, [Validators.required]],
      fecha_de_nacimiento_usuario: [null, [Validators.required]],
      clave_usuario: [null, [Validators.required]],
    });
    this.empresaForm = this.fb.group({
      nombre_empresa_usuario: [null, [Validators.required]],
      correo_empresa_usuario: [null, [Validators.required]],
      telefono_empresa_usuario: [null, [Validators.required]],
      subdominio_empresa_usuario: [null, [Validators.required]],
      cuenta_activa_subdominio: [1, [Validators.required]],
    });
    this.getLoggedUser();
    this.empresaForm.controls['cuenta_activa_subdominio'].disable();
  }
  applyFilterTransaction(event: Event): void {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSourceTrans.filter = filterValue.trim().toLowerCase();
  }
  formatDateForEdit(date) {
    let y = date.slice(0, 4);
    let m = date.slice(5, 7);
    let d = date.slice(8, 10);

    return `${y}-${m}-${d}`;
  }
  getLoggedUser() {
    this.usuario = this.svUtils.getLoggedUser();

    if (this.usuario['fecha_de_nacimiento_usuario']) {
      this.fecha_de_nacimiento_usuario = this.formatDateForEdit(
        this.usuario['fecha_de_nacimiento_usuario']
      );
    }
    this.usuarioForm.controls['correo_usuario'].disable();

    if (this.usuario['id_empresa_perteneciente']) {
      //console.log("Get company in logged user")
      this.getCompany(this.usuario['id_empresa_perteneciente']);
    }

    this.usuarioForm.setValue({
      nombres_usuario: this.usuario['nombres_usuario'] || '',
      apellidos_usuario: this.usuario['apellidos_usuario'] || '',
      telefono_usuario: this.usuario['telefono_usuario'] || '',
      fecha_de_nacimiento_usuario: this.fecha_de_nacimiento_usuario,
      pais_usuario: this.usuario['pais_usuario'] || '',
      correo_usuario: this.usuario['correo_usuario'] || '',
      clave_usuario: atob(this.usuario['clave_usuario']) || '',
    });
    this.getUserTransactions(this.usuario['id_usuario']);
  }

  getUserInfo() {
    this.svUser.getUser(this.usuario['id_usuario']).subscribe((resp) => {
      if (resp['status'] === 'success') {
        localStorage.setItem(
          'ud',
          btoa(JSON.stringify(resp['body']['data'][0]))
        );

        this.usuario = this.svUtils.getLoggedUser();
      }
    });
  }

  getCompany(id_empresa_usuario) {
    this.svUser.getCompany(id_empresa_usuario).subscribe((resp) => {
      if (resp['body']['status'] === 'success') {
        resp = resp['body']['data'][0];
        localStorage.setItem('empresa', JSON.stringify(resp));
        this.empresa = resp;

        if (this.empresa['es_demo'] == 'demo_default') {
          this.empresaForm.controls['nombre_empresa_usuario'].disable();
          this.empresaForm.controls['telefono_empresa_usuario'].disable();
        }
        this.empresaForm.controls['correo_empresa_usuario'].disable();
        this.empresaForm.controls['subdominio_empresa_usuario'].disable();
        this.empresaForm.controls['cuenta_activa_subdominio'].disable();

        this.empresaForm.setValue({
          nombre_empresa_usuario: this.empresa['nombre_empresa_usuario'] || '',
          telefono_empresa_usuario:
            this.empresa['telefono_empresa_usuario'] || '',
          subdominio_empresa_usuario:
            this.empresa['subdominio_empresa_usuario'] || '',
          correo_empresa_usuario: this.empresa['correo_empresa_usuario'] || '',
          cuenta_activa_subdominio:
            this.empresa['cuenta_activa_subdominio'] || '',
        });
      }
    });
  }

  updateUser(formValues) {
    const request = {
      id_usuario: this.usuario.id_usuario,
      id_parametro_rol: this.usuario.id_parametro_rol,
      nombres_usuario: formValues['nombres_usuario'],
      apellidos_usuario: formValues['apellidos_usuario'],
      telefono_usuario: formValues['telefono_usuario'],
      pais_usuario: formValues['pais_usuario'],
      fecha_de_nacimiento_usuario: formValues['fecha_de_nacimiento_usuario'],
      clave_usuario: formValues['clave_usuario'],
    };

    this.svUser.updateUser(request).subscribe(
      (data) => {
        if (data.status == 'success') {
          this.alertsService.showSnackBar('Datos actualizados!', 3000);
          Swal.fire(
            'Operación exitosa!',
            'Usuario actualizado de manera exitosa',
            'success'
          );
        } else {
          Swal.fire('Actualizar cuenta', data['errorMessage'], 'warning');
        }
      },
      (err) => {
        Swal.fire(
          'Actualizar cuenta',
          'Algo salió mal al intentar actualizar la información, contacta al administrador',
          'error'
        );
      }
    );
  }

  addUpdateCompany(formValues, action) {
    const request = {
      id_usuario: this.usuario.id_usuario,
      nombre_empresa_usuario: formValues['nombre_empresa_usuario'] || '',
      telefono_empresa_usuario: formValues['telefono_empresa_usuario'] || '',
    };

    if (action == 'add') {
      request[
        'subdominio_empresa_usuario'
      ] = `${formValues['subdominio_empresa_usuario']}.infoverses.com`;

      request['correo_empresa_usuario'] = formValues['correo_empresa_usuario'];

      let subdominio = request['subdominio_empresa_usuario'];

      var today = new Date();
      var dd = String(today.getDate()).padStart(2, '0');
      var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
      var yyyy = today.getFullYear();

      let subdminio_data = {
        id_usuario_subdominio: this.usuario.id_usuario,
        nombre_subdominio: subdominio,
        fecha_pago_subdominio: mm + '/' + dd + '/' + yyyy,
        cuenta_activa_subdominio: '1',
      };

      this.svSubdominios.addDomain(subdminio_data).subscribe((resp_subd) => {
        if (resp_subd['status'] === 'success') {
          this.svUser.addCompany(request).subscribe(
            (resp_c) => {
              if (resp_c.status == 'success') {
                let data_i = {
                  es_empresa: 1,
                  id_usuario: this.usuario.id_usuario,
                  id_empresa_perteneciente:
                    resp_c['result']['id_empresa_usuario'],
                  subdominio_empresa: request['subdominio_empresa_usuario'],
                };
                this.getCompany(resp_c['result']['id_empresa_usuario']);
                this.svUser.updateIsCompany(data_i).subscribe((resp_i) => {
                  this.alertsService.showSnackBar('Datos actualizados!', 3000);
                  if (resp_i.status == 'success') {
                    /*  */
                    this.getUserInfo();

                    Swal.fire(
                      'Operación exitosa!',
                      'Usuario agregado de manera exitosa',
                      'success'
                    );
                  } else {
                    Swal.fire(
                      'Crear empresa',
                      resp_i['errorMessage'],
                      'warning'
                    );
                  }
                });
              } else {
                Swal.fire('Crear empresa', resp_c['errorMessage'], 'warning');
              }
            },
            (err) => {
              Swal.fire(
                'Crear empresa',
                'Algo salió mal al intentar crear la empresa, contacta al administrador',
                'error'
              );
            }
          );
        }
      });
      return;
    }
    if (this.empresa['subdominio_empresa_usuario']) {
      this.empresaForm.controls['subdominio_empresa_usuario'].disable();
    }

    request['id_empresa_usuario'] = this.empresa['id_empresa_usuario'];
    this.svUser.updateCompany(request).subscribe(
      (data) => {
        if (data.status == 'success') {
          this.alertsService.showSnackBar('Datos actualizados!', 3000);
          Swal.fire(
            'Operación exitosa!',
            'Empresa actualizado de manera exitosa',
            'success'
          );
        } else {
          Swal.fire('Actualizar la Empresa', data['errorMessage'], 'warning');
        }
      },
      (err) => {
        Swal.fire(
          'Actualizar cuenta',
          'Algo salió mal al intentar actualizar la información, contacta al administrador',
          'error'
        );
      }
    );
  }

  getUserTransactions(id_usuario) {
    this.svTransactions.getUserTransactions(id_usuario).subscribe((_resp) => {
      if (_resp) {
        if (_resp['body']['status'] === 'success') {
          this.listTransactions = _resp['body']['data'];

          this.dataSourceTrans = new MatTableDataSource(this.listTransactions);
          this.dataSourceTrans.paginator = this.paginatorTrans;
          this.dataSourceTrans.sort = this.sortTrans;
        }
      }
    });
  }
}
